import React, {useEffect, useState} from "react";
import {gql} from "@apollo/client";
import {useQuery} from "@apollo/client";
import {useAuthStore} from "../../store/useAuthStore";
import {getAccessKey} from "../../util/secureAuthStorage";

export const GET_MY_INFO = gql`
  query getMyAccountInfos {
    seeMe {
      id
      login_type
      username
      nickname
      access_token
      nickname
      following_count
      follower_count
      bio
      resizedSmallImage
      resizedBigImage
      email
      phone
      gender
      createdAt
      updatedAt
      isBusiness
      seller {
        id
        income
        rating
        sold_count
        fee
        is_certified
        feeWavedUntil
        is_tester
        seller_account {
          bank_name
          account_holder_name
          bank_account
        }
      }
    }
  }
`;

export default function AutoLogin() {
    const {login, finishAuthInitialization, failAuthInitialization} = useAuthStore();
    const [hasAccessToken, setHasAccessToken] = useState(null);
    const {data, loading, error} = useQuery(GET_MY_INFO, {
        skip: hasAccessToken !== true,
        fetchPolicy: 'network-only'
    });

    useEffect(() => {
        if (hasAccessToken === false) {
            finishAuthInitialization();
            return;
        }

        if (hasAccessToken !== true || loading) return;

        if (data?.seeMe?.id) {
            login(data.seeMe);
            return;
        }

        // 일시적인 네트워크/서버 오류에서는 저장된 세션을 삭제하지 않는다.
        // 최종 인증 실패(403 및 refresh 실패)는 Apollo error link의 logout()이 처리한다.
        if (error || data?.seeMe == null) {
            failAuthInitialization();
        }
    }, [data, error, failAuthInitialization, finishAuthInitialization, hasAccessToken, loading, login]);

    useEffect(() => {
        setHasAccessToken(Boolean(getAccessKey()));
    }, []);

    return <></>
}
